import { styled } from "theme/default/styled";

import { Input } from "../Input/Input.component";

export const SResetPasswordFormPassword = styled(Input)`
  margin-top: 20px;
  margin-bottom: 5px;
`;
